



















































import Vue from 'vue';

import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  EngagementRewardVersion, EngagementReward,
} from '@/api/engagementrewards';
import { DateTool } from '@/util';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';

@Component({
  components: {
    KCardHeader, KCardHeaderBtn,
  },
})
export default class EngagementRewardVersionSelector extends Vue {
  @Prop()
  value!: EngagementRewardVersion;

  @Prop()
  reward!: EngagementReward;

  @Prop({ default: false })
  editing!: boolean;

  currentSelection: EngagementRewardVersion | null = null;

  currentVersion: EngagementRewardVersion | null = null;

  mounted() {
    this.onValueChange();
    this.onNewReward();
  }

  @Watch('currentSelection')
  onSelectionChange() {
    this.$emit('input', this.currentSelection);
  }

  @Watch('value')
  onValueChange() {
    this.currentSelection = this.value;
  }

  @Watch('reward')
  onNewReward() {
    this.currentVersion = this.reward.getCurrentVersion();
  }

  onBackButton() {
    this.$emit('back');
  }

  getVersionDescription(version: EngagementRewardVersion) : string {
    if (!version || !version.designStartDate) {
      return '';
    }

    let startString : string = '';
    if (this.currentVersion === version) {
      startString = 'Current Reward Version';
    } else {
      startString = 'Reward Version';
    }

    const versionIndex = this.getVersionIndex(version);

    const versions = this.reward.versions;
    if (versions.length === 1 || versionIndex === 0) {
      return `${startString} - ${DateTool.toFriendlyFormatFromIsoFormatString(version.designStartDate)}`;
    }


    return `${startString} - ${DateTool.toFriendlyFormatFromIsoFormatString(version.designStartDate)} - ${DateTool.subtractOneDay(
      versions[versionIndex - 1].designStartDate,
    )}`;
  }

  getVersionIndex(version: EngagementRewardVersion) : number {
    const isEqual = (element : EngagementRewardVersion) => element === version;
    return this.reward.versions.findIndex(isEqual);
  }
}
